module.exports = __webpack_public_path__ + "static/iCloud_4-36c725778d61a3a77f8aa34a5da9a9c8.png";